// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {toaster} from '@cypro/ui/toaster'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeletePatientPrescription() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.patients.deleteTherapySequence(payload), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}

export function useConfirmDeletePatientPrescription() {
  const {t} = useTranslate('common')
  const deletePrescription = useDeletePatientPrescription()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={t('delete_therapy_sequence_dialog.title')}
            description={t('delete_therapy_sequence_dialog.description')}
          />
        ),
      })
      if (!confirmed) return

      const deleteRes = await deletePrescription(payload)
      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error

      toaster.success({title: t('success'), description: t('resource_deleted_successfully')})
    },
    [t, deletePrescription]
  )
}
